import React, { forwardRef } from 'react'

import Icon from '../../../Icon/Icon'
import Text from '../../../Text/Text'
import Tooltip from '../../../Tooltip/Tooltip'
import type { DataTableViewLatest } from '../DataTableViewSelector.types'
import { DataTableViewTabStyled } from './DataTableViewTab.styles'

export interface DataTableViewTabProps {
  isSelectedView?: boolean
  onClick: (view: DataTableViewLatest) => void
  view: DataTableViewLatest
}

const DataTableViewTab = forwardRef<HTMLButtonElement, DataTableViewTabProps>(
  ({ isSelectedView, onClick, view, ...props }, ref) => {
    const { name, description, icon } = view
    return (
      <Tooltip
        tooltip={description}
        off={!description}
        variant="black"
        placement="top"
        fallbackPlacements={['bottom', 'auto']}
      >
        <DataTableViewTabStyled
          data-e2e={`view-table-${name}`}
          data-selected={isSelectedView ? 'true' : 'false'}
          onClick={() => onClick(view)}
          ref={ref}
          {...props}
        >
          <Icon name={icon} faStyle="far" />

          <Text>{name}</Text>
        </DataTableViewTabStyled>
      </Tooltip>
    )
  }
)

export default DataTableViewTab
